import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import {
  ForEachModel,
  ValueToCollection,
  WhenCollectionIsNotEmpty,
  WhenModelValue
} from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import * as UI from 'ui'

export default function OrderTransactionsSmartview () {
  const infoText = (
    <UI.WithSubtitle subtitle={<Displays.DateTime name='attempted_at' />}>
      <Displays.Text name='delivery_type_info' /> (<Displays.Text name='status_info' />)
    </UI.WithSubtitle>
  )

  return (
    <Translator namespace='smartviews.order_transactions_overview'>
      <Smartview header={<Translation name='title' />}>
        <ValueToCollection name='delivery_transactions'>
          <WhenCollectionIsNotEmpty>
            <UI.VerticalList>
              <ForEachModel>
                <div className='space-y-4 flex flex-col'>
                  <WhenModelValue name='status' condition='failed'>
                    <UI.Text color='red'>
                      {infoText}
                    </UI.Text>
                    <UI.Text size='sm' weight='light'>
                      <Displays.Text name='status_reason_info' />
                    </UI.Text>
                  </WhenModelValue>
                  <WhenModelValue name='status' condition='completed'>
                    <UI.Text color='green'>
                      {infoText}
                    </UI.Text>
                  </WhenModelValue>
                  <WhenModelValue name='status' condition='draft'>
                    <UI.Text color='yellow'>
                      {infoText}
                    </UI.Text>
                  </WhenModelValue>
                  <Displays.Link name='download_url' label={<Translation name='view_file' />} />
                </div>
              </ForEachModel>
            </UI.VerticalList>
          </WhenCollectionIsNotEmpty>
        </ValueToCollection>
      </Smartview>
    </Translator>
  )
}
